import type { Ref } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DisplayDocument, type DocumentControl } from "@/components/session/DisplayDocument";
import type { ScenarioDisplaySource } from "@/lib/powtoon-be/types";

/**
 * The document pane inside a live session. When the avatar owns presentation
 * (D-ID / Kaltura client tools) the learner also gets a manual close button, so
 * they are never stuck with a document the avatar forgot to put away.
 */
export function PresentedDocument({
  scenarioId,
  source,
  publicLinkToken,
  controlRef,
  onClose,
}: {
  scenarioId: string;
  source: ScenarioDisplaySource;
  publicLinkToken?: string;
  controlRef?: Ref<DocumentControl>;
  /** Omit when the document is pinned for the whole session. */
  onClose?: () => void;
}) {
  return (
    <div className="relative h-full w-full">
      <DisplayDocument
        scenarioId={scenarioId}
        source={source}
        publicLinkToken={publicLinkToken}
        controlRef={controlRef}
      />
      {onClose && (
        <Button
          onClick={onClose}
          size="icon"
          variant="secondary"
          className="absolute top-3 right-3 z-20 rounded-lg bg-card/70 backdrop-blur"
          aria-label="Close document"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
